import React from 'react';
import { Patient } from '@/modules/surgicalEvent';
import { Avatar, Stack, Typography } from '@mui/material';
import { FormattedDate, TranslatedText } from '@ianesthesie-kit/core';

export const PatientInfo = ({ patient }: { patient?: Patient }) => {
  if (!patient) {
    return null;
  }

  return (
    <Stack data-sentry-mask mb={2} direction="row" alignItems="center" gap={2}>
      <Avatar
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          width: 50,
          height: 50,
          fontSize: 20,
          fontWeight: 500
        }}
        imgProps={{ crossOrigin: 'anonymous' }}
        src={patient?.facePicture?.path}
      >
        {patient?.firstName?.[0]}
        {patient?.lastName?.[0]}
      </Avatar>
      <Stack>
        <Typography color="text.primary" fontWeight="500" fontSize="large">
          {patient.name}
        </Typography>
        <Typography
          color="text.secondary"
          fontSize="medium"
          display="flex"
          flexWrap="nowrap"
        >
          <FormattedDate
            format="P"
            color="inherit"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component="span"
          >
            {patient.birthDate}
          </FormattedDate>
          ,&nbsp;{patient.age}&nbsp;
          <TranslatedText id="doctor-dashboard.yearsOld.abbr" />
        </Typography>
      </Stack>
    </Stack>
  );
};
